<script setup lang="ts">
import ChildUserLoginCard from '../../components/ChildUserLoginCard/ChildUserLoginCard.vue';
import { useChildUserLogin } from './useChildUserLogin';

const { login } = useChildUserLogin();
// interface Props {
//   // moduleValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:moduleValue', payload: string): void
// }>()
</script>

<template>
  <div class="flex column items-center justify-center h-full text-white">
    <!-- Compact logo + title, matching the other auth screens. This replaced a
         `WelcomeToFlashCard` hero that rendered the same mark at up to 3rem
         type, which read as a different product next to the sibling pages. -->
    <q-img
      src="/img/logo_set_white.svg"
      no-spinner
      alt="SET App"
      class="set-auth-logo"
    />
    <h3 class="text-h4 q-my-md q-px-sm text-center text-uppercase">
      {{ $t('CHILD_ACCOUNT_LOGIN') }}
    </h3>
    <ChildUserLoginCard
      flat
      class="bg-transparent"
      @login="login"
    >
      <template #actions>
        <q-btn
          flat
          color="primary"
          class="text-caption"
          text-color="accent"
          :label="$t('PARENT_ACCOUNT_LOGIN')"
          :to="{ name: 'users.signin' }"
        />
      </template>
    </ChildUserLoginCard>
  </div>
</template>

<style scoped>
.set-auth-logo {
  width: 11rem;
  max-width: 60vw;
}
</style>
